/* tslint:disable */

declare var Object: any;
export interface PropertyTypeInterface {
  "groupName"?: string;
  "name"?: string;
  "is_taxable"?: boolean;
  "tax_percentage"?: number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class PropertyType implements PropertyTypeInterface {
  "groupName": string;
  "name": string;
  "is_taxable": boolean;
  "tax_percentage": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: PropertyTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyType`.
   */
  public static getModelName() {
    return "PropertyType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyType for dynamic purposes.
  **/
  public static factory(data: PropertyTypeInterface): PropertyType{
    return new PropertyType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyType',
      plural: 'PropertyTypes',
      path: 'PropertyTypes',
      idName: 'id',
      properties: {
        "groupName": {
          name: 'groupName',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "is_taxable": {
          name: 'is_taxable',
          type: 'boolean'
        },
        "tax_percentage": {
          name: 'tax_percentage',
          type: 'number',
          default: 16
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
